/*
 * @Author: JDY
 * @Date: 2020-08-05 15:40:34
 * @LastEditTime: 2021-05-12 15:34:06
 * @LastEditors: JDY
 * @Description: In User Settings Edit
 * @FilePath: \new_if_admind:\phpstudy_pro\WWW\lfadmin\src\main.js
 */
// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import i18n from './locales'
import { VueAxios } from './utils/request'
import ProLayout, { PageHeaderWrapper } from '@ant-design-vue/pro-layout'
import themePluginConfig from '../config/themePluginConfig'
import { Icon } from 'ant-design-vue' // icon

import bootstrap from './core/bootstrap'
import Viewer from 'v-viewer'
import moment from 'moment'
import './core/lazy_use'
import './permission' // permission control
import './utils/filter' // global filter
import './global.less'
import 'viewerjs/dist/viewer.css'
import qee from 'qf-export-excel' // 导出

Vue.config.productionTip = false

// 导出
const outputXlsxFile = (header, data, xlsxName) => {
    header.filter(item => {
        const dataIndex = item.key.split('.')
        const key = dataIndex[0]
        const key2 = dataIndex[1]
        const newsKey = key + '_' + key2
        if (dataIndex.length > 1) {
            item.key = newsKey
            data.filter(table => {
                if (table[key]) {
                    table[newsKey] = table[key][key2]
                }
            })
        }
    })
    qee(header, data, xlsxName)
}

// iconfont
const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2393151_p6kc6nbvd9b.js'
})

Vue.prototype.outputXlsxFile = outputXlsxFile

Vue.prototype.globalUrl = 'https://training.linuxfoundation.cn'

// http://web.osctraining.com
// https://training.linuxfoundation.cn

Vue.prototype.moment = moment

// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
Vue.use(Viewer)
Vue.component('pro-layout', ProLayout)
Vue.component('page-header-wrapper', PageHeaderWrapper)
Vue.component('icon-font', IconFont)

window.umi_plugin_ant_themeVar = themePluginConfig.theme

new Vue({
    router,
    store,
    i18n,
    created: bootstrap,
    render: h => h(App)
}).$mount('#app')
